import LinkService from 'mangools-commons/dist/services/LinkService';

import { LinkRefSources } from 'mangools-commons/dist/constants/LinkRefSources';

LinkService.source = LinkRefSources.LINKMINER_APP;
